import { createSlice } from '@reduxjs/toolkit'
import {getWorkerServiceStatus} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';
const initialState= {
    workerServiceStatus: { },
  loading: "idle",
  error: null }

const workerServiceSlice = createSlice({
  name: 'workerService',
  initialState,
  reducers: {
    clearorkerServiceError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getWorkerServiceStatus.pending]: (state) => {
        state.loading = "loading";
        state.error = null
      },
    [getWorkerServiceStatus.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.workerServiceStatus = action.payload
    },
    [getWorkerServiceStatus.rejected]: (state, action) => {
        state.loading = "failed";
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearWorkerServiceError} = workerServiceSlice.actions;
export default workerServiceSlice.reducer